import React from 'react'
import { EmptyContent } from '@ztechapps/webui.util'

export const EmptyUseAndCare = () => {
  return (
    <div className="p-5 text-warning">
      <EmptyContent
        icon="circle-info"
        message="There is no use and care instructions here!"
        subMessage="The admin intentionally remove or de-activate this use and care information."
      />
    </div>
  )
}
